export const CusomerDefaultFilters = {
  sortBy: "recentlyAdded",
  page: 1,
  limit: 10,
  search: "",
  plan: "",
  billingCycle: "",
  status: "",
  fromDate: "",
  toDate: "",
};

export const CustomerDefaultMultiFilter = [
  {
    id: 1,
    label: "Plan",
    value: "plan",
    options: [
      { id: 1, label: "All", value: "all", visible: false },
      { id: 2, label: "Trial", value: "Trial", visible: false },
      { id: 3, label: "Basic", value: "Basic", visible: false },
      { id: 4, label: "Pro", value: "Pro", visible: false },
      { id: 5, label: "Premium", value: "Premium", visible: false },
    ],
  },
  {
    id: 2,
    label: "Billing Cycle",
    value: "billingCycle",
    options: [
      { id: 1, label: "All", value: "all", visible: false },
      { id: 2, label: "Monthly", value: "monthly", visible: false },
      { id: 3, label: "Yearly", value: "yearly", visible: false },
    ],
  },
  {
    id: 3,
    label: "Status",
    value: "status",
    options: [
      { id: 1, label: "All", value: "all", visible: false },
      { id: 2, label: "Active", value: "active", visible: false },
      { id: 3, label: "Cancelled", value: "canceled", visible: false },
      { id: 4, label: "Past Due", value: "past_due", visible: false },
      { id: 5, label: "Incomplete", value: "incomplete", visible: false },
      {
        id: 6,
        label: "Incomplete Expired",
        value: "incomplete_expired",
        visible: false,
      },
    ],
  },
  {
    id: 4,
    label: "Date Range",
    value: "dateRange",
    options: [],
  },
];

export const FeedbackDefaultFilters = {
  sortBy: "recentlyAdded",
  page: 1,
  limit: 10,
  search: "",
  isArchived: false,
};

// export const FeedbackDefaultMultiFilter = [
//   {
//     id: 1,
//     label: "Role",
//     value: "role",
//     options: [
//       { id: 1, label: "All", value: "all", visible: false },
//       { id: 2, label: "Landlord", value: "Landlord", visible: false },
//       { id: 3, label: "Tenant", value: "Tenant", visible: false },
//     ],
//   },
//   {
//     id: 2,
//     label: "Experience",
//     value: "experience",
//     options: [
//       { id: 1, label: "All", value: "all", visible: false },
//       { id: 2, label: "Disappointed", value: "Disappointed", visible: false },
//       { id: 3, label: "Poor", value: "Poor", visible: false },
//       { id: 4, label: "Average", value: "Average", visible: false },
//       { id: 5, label: "Good", value: "Good", visible: false },
//       { id: 6, label: "Fantastic", value: "Fantastic", visible: false },
//     ],
//   },
// ];

export const FeedbackDefaultMultiFilter = [
  { id: 1, label: "Landlord", value: "Landlord", visible: false },
  { id: 2, label: "Tenant", value: "Tenant", visible: false },
  { id: 3, label: "Disappointed", value: "Disappointed", visible: false },
  { id: 4, label: "Poor", value: "Poor", visible: false },
  { id: 5, label: "Average", value: "Average", visible: false },
  { id: 6, label: "Good", value: "Good", visible: false },
  { id: 7, label: "Fantastic", value: "Fantastic", visible: false },
  { id: 8, label: "Archive", value: "isArchived", visible: false },
];

export const RevenueDefaultFilters = {
  sortBy: "asc",
  page: 1,
  limit: 10,
  search: "",
  fromDate: "",
  toDate: "",
};

export const RevenueDefaultMultiFilter = [
  {
    id: 1,
    label: "Date Range",
    value: "dateRange",
    options: [],
  },
];

export const TicketDefaultFilters = {
  status: "",
  customerEmail: "",
  dateFrom: "",
  dateTo: "",
  search: "",
  limit: 10,
  starting_after: "",
  category: "",
};

export const TicketDefaultMulti = [
  {
    id: 1,
    label: "Status",
    value: "status",
    options: [
      { id: 1, label: "Submitted", value: "submitted" },
      { id: 2, label: "In Progress", value: "in_progress" },
      { id: 3, label: "Resolved", value: "resolved" },
      // { id: 4, label: "Closed", value: "closed" },
    ],
  },
  // {
  //   id: 2,
  //   label: "Category",
  //   value: "category",
  //   options: [
  //     { id: 1, label: "Customer", value: "customer" },
  //     { id: 2, label: "Back-office", value: "Back-office" },
  //     { id: 3, label: "Tracker", value: "Tracker" },
  //   ],
  // },
  {
    id: 3,
    label: "Date",
    value: "date",
    options: [
      {
        id: 1,
        label: "Today",
        value: {
          fromDate: new Date().toISOString().split("T")[0],
          toDate: new Date().toISOString().split("T")[0],
        },
      },
      {
        id: 2,
        label: "Last 7 Days",
        value: {
          fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
            .toISOString()
            .split("T")[0],
          toDate: new Date().toISOString().split("T")[0],
        },
      },
      {
        id: 3,
        label: "Last 30 Days",
        value: {
          fromDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
            .toISOString()
            .split("T")[0],
          toDate: new Date().toISOString().split("T")[0],
        },
      },
    ],
  },
];
